import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const selectedAdminUser = createSlice({
    name: "user",
    initialState,
    reducers: {
        setSelectedAdminUser: (state, {payload}) => payload,
    }
})

export const { setSelectedAdminUser } = selectedAdminUser.actions

export default selectedAdminUser.reducer